import React, { useEffect, useState } from "react";
import styles from './AddTreatment.module.scss';

import { useDispatch } from "react-redux";
import { getApplicators, getClinics, getPlatforms } from "../../store/data-slice";
import { $t } from "../../helpers/translator";
import api from "../../helpers/api";
import _ from "lodash";
import SkinTypeSelector from "../miscellaneous/SkinTypeSelector/SkinTypeSelector";
import MultiSelectWithValidation from "../miscellaneous/MultiSelectWithValidation/MultiSelectWithValidation";
import InputWithValidation from "../miscellaneous/InputWithValidation/InputWithValidation";
import { MdAddCircleOutline, MdRemoveCircleOutline } from "react-icons/md";
import { setAlert } from "../../store/alerts-slice";

const AddTreatment = (props) => {
    const dispatch = useDispatch();

    const [ formSent, setFormSent ] = useState(false);

    const [ applicatorOptions, setApplicatorOptions ] = useState([]);
    const [ platformOptions, setPlatformOptions ] = useState([]);

    const [ staffOptions, setStaffOptions ] = useState([]);
    const [ patientOptions, setPatientOptions ] = useState([]);
    const [ areasOptions, setAreasOptions ] = useState([]);

    const [ gridSizeOptions, setGridSizeOptions ] = useState([]);
    const [ treatmentModesOptions, setTreatmentModesOptions ] = useState([
        {
            value: 0,
            label: 'HR',
            fields: [ 'fluence', 'frequency', 'lasing_time' ],
        },
        {
            value: 1,
            label: 'SHR',
            fields: [ 'fluence', 'energy' ],
        },
        {
            value: 2,
            label: 'STACK',
            fields: [ 'fluence', 'energy' ],
        }
    ]);

    const [ values, setValues ] = useState({
        created_at: null,
        platform: null,
        applicator: null,
        staff: null,
        patient: null,
        mode: null,
        skin_id: null,
        grid_size: null,
    });
    const [ formError, setFormError ] = useState('')

    const [ showTreatmentGridsRows, setShowTreatmentGridsRows ] = useState(false);
    const [ treatmentGrids, setTreatmentGrids ] = useState([
        {
            fluence: null,
            temperature: null,
            energy: null,
            duration: null,
        },
    ])
    const treatmentModes = {
        0: {
            name: 'hr',
            applicators: {
                6: {
                    girdSizes: [ 600, 700, 800, 900 ],
                },
                default: {
                    girdSizes: null,
                }
            }
        },
        1: {
            name: 'shr',
            applicators: {
                6: {
                    girdSizes: [ 600, 700, 800, 900 ],
                },
                default: {
                    girdSizes: null,
                }
            }
        },
        2: {
            name: 'stack',
            applicators: {
                6: {
                    girdSizes: [ 25, 50, 75 ],
                },
                default: {
                    girdSizes: null,
                }
            }
        },
    };


    useEffect(() => {
        getOptions();
    }, []);

    useEffect(() => {
        setFormError('')
    }, [ values ]);

    useEffect(() => {
        if (values.platform && values.applicator && values.skin_id && values.mode) {
            if (values.applicator.handle_type_id === 6 && !values.grid_size) {
                return;
            }
            getRecommendedTreatmentParameters();
            setShowTreatmentGridsRows(true);
        }
    }, [ values.platform, values.applicator, values.mode, values.grid_size, values.skin_id ]);

    /**
     * setting grid size options when applicator and treatment mode are selected
     */
    useEffect(() => {
        if (values.applicator && values.mode) {
            let sizes = treatmentModes[ values.mode.value ].applicators[ treatmentModes[ values.mode.value ].applicators[ values.applicator.handle_type_id ] ? values.applicator.handle_type_id : 'default' ].girdSizes;
            let sizeOptions = [];
            if (sizes) {
                _.forEach(sizes, (v, k) => {
                    sizeOptions.push({
                        value: v,
                        label: v
                    })
                })
            }
            setGridSizeOptions(sizeOptions);
        }
    }, [ values.mode, values.applicator ]);

    useEffect(() => {
        fieldChangeHandler('grid_size', { value: null });
    }, [ values.applicator ]);


    async function getOptions() {
        // let clinics = await dispatch(getClinics());
        // setClinicOptions(clinics)
        let platforms = await dispatch(getPlatforms());
        setPlatformOptions(platforms);
        let applicators = await dispatch(getApplicators());
        setApplicatorOptions(applicators);

        try {
            let patientsRes = await api.get(`general/patients`);
            // console.log('addTR patientsRes', patientsRes);
            _.forEach(patientsRes.data.data, (v, k) => {
                v.label = `${v.name} (${v.patient_id})`;
                v.value = v.patient_id;
            })
            patientsRes.data.data.unshift({
                label: 'N/A',
                value: '',
            })
            setPatientOptions(patientsRes.data.data)

            let staffRes = await api.get(`general/staff`);
            // console.log('addTR staffRes', staffRes)
            _.forEach(staffRes.data.data, (v, k) => {
                v.label = v.name;
                v.value = v.id;
            })
            staffRes.data.data.unshift({
                label: 'N/A',
                value: '',
            })
            setStaffOptions(staffRes.data.data)

            let areasRes = await api.get(`general/areas`);
            // console.log('addTR areasRes', areasRes)
            _.forEach(areasRes.data.data, (v, k) => {
                v.label = v.name;
                v.value = v.id;
            })
            setAreasOptions(areasRes.data.data)
        } catch (e) {
            console.error(e);
        }
    }

    async function getRecommendedTreatmentParameters() {
        // console.log('<<<<<<<<<< all data is filled!', values);
        try {
            let url =
                `treatments/data?`
                + `machine_id=${values.platform.id}`
                + `&handle_id=${values.applicator.id}`
                + `&skin_type=${values.skin_id.value}`
                + (values.grid_size && values.grid_size.value !== undefined ? `&grid_size=${values.grid_size.value}` : ``)
                + (values.mode && values.mode.value !== undefined ? `&treatment_mode=${values.mode.value}` : ``);

            let res = await api.get(url);
            // console.log('recommendationsRes', res)

            if (!res || !res.data || !res.data.data) {
                return;
            }

            // console.log('res', res)

            let updatedValues = {
                fluence: { errors: Array(0), value: res.data.data.fluence ? res.data.data.fluence.toString() : '0' },
                energy: { errors: Array(0), value: res.data.data.energy ? res.data.data.energy.toString() : '0' },
                frequency: { errors: Array(0), value: res.data.data.frequency ? res.data.data.frequency.toString() : '0' },
                lasing_time: { errors: Array(0), value: res.data.data.lasing_time ? res.data.data.lasing_time.toString() : '0' }
            }

            let updatedValuesArr = []
            _.forEach(treatmentGrids, (v, k) => {
                updatedValuesArr.push(updatedValues)
            })
            // console.log('arrrrrrr', updatedValuesArr)

            setTreatmentGrids(updatedValuesArr)
        } catch (e) {
            console.error('err getting treatments/data', e)
        }
    }

    function fieldChangeHandler(fieldName, selection) {
        // console.log('handler', fieldName, selection);

        if (!selection || !selection.value === undefined) {
            return;
        }

        let updatedValues = { ...values };
        updatedValues[ fieldName ] = selection.value;
        setValues(updatedValues)
        // console.log('>>', updatedValues)
    }

    function treatmentGridChangeHandler(e, k, fieldName, value) {
        // console.log('handler2', k, fieldName, value);
        if (!value || !value.value || !treatmentGrids[ k ]) {
            return;
        }

        let updatedTreatmentGrids = [ ...treatmentGrids ];

        let newValue = value.value.value;
        let newErrors = [];
        _.forEach(value.value.errors, (v, k) => {
            newErrors.push(v)
        })

        updatedTreatmentGrids[ k ][ fieldName ] = {
            value: newValue,
            errors: newErrors
        }

        setTreatmentGrids(updatedTreatmentGrids)
    }

    function changeGridsCount(e, count) {
        e.stopPropagation();
        let treatmentGridsUpdated = [ ...treatmentGrids ]
        let lastGridValues = { ...treatmentGrids[ treatmentGrids.length - 1 ] }

        if (!lastGridValues) {
            return;
        }

        if (count) {
            treatmentGridsUpdated.push({
                fluence: { errors: Array(0), value: lastGridValues.fluence.value },
                energy: { errors: Array(0), value: lastGridValues.energy.value },
                frequency: { errors: Array(0), value: lastGridValues.frequency.value },
                lasing_time: { errors: Array(0), value: lastGridValues.lasing_time.value }
            })
        } else {
            treatmentGridsUpdated.pop()
        }

        setTreatmentGrids(treatmentGridsUpdated)
    }

    async function formSentClickHandler() {
        setFormError('');
        setFormSent(true);
        // console.log('send form click handler...')
        let errors = validate();

        if (errors.length) {
            setFormError($t('global.treatments.errorsFound'));
            return;
        }

        let payload = {
            machine_id: values.platform ? values.platform.value : null,
            staff_id: values.staff ? values.staff.value : null,
            patient_id: values.patient ? values.patient.value : null,
            handle_id: values.applicator ? values.applicator.value : null,
            area_id: values.area ? values.area.value : null,
            skin_type: values.skin_id ? values.skin_id.value : null,
            grid_size: values.grid_size ? values.grid_size.value : null,
            treatment_mode: values.mode ? values.mode.value : null,
            treatments: [],
            created_at: values.created_at.replace('T', ' ') + ':00',
        }

        _.forEach(treatmentGrids, (v, k) => {
            payload.treatments.push({
                grid: k + 1,
                energy: v.energy.value,
                fluence: v.fluence.value,
                frequency: v.frequency.value,
                lasing_time: v.lasing_time.value,
            })
        })

        // console.log('>>>>>> payload', payload);

        try {
            let res = await api.post('treatments', payload);
            // console.log('>>>>>res:', res);
            if (res && res.success && res.data && res.data.success) {
                dispatch(setAlert({ type: 'success' }))
                props.onSuccess();
                return;
            }
            dispatch(setAlert({ type: 'error' }))
        } catch (e) {
            dispatch(setAlert({ type: 'error' }))
        }
    }

    function validate() {
        let errors = [];

        let requiredSelectionFields = [
            'created_at',
            'staff',
            'patient',
            'area',
            'skin_id',
            'platform',
            'applicator',
            'mode',
            ...values.applicator && values.applicator.handle_type_id === 6 ? [ 'grid_size' ] : [],
        ];
        _.forEach(requiredSelectionFields, (v, k) => {
            if (!values[ v ]) {
                errors.push({
                    id: v,
                    error: 'This field is required'
                })
            }
        })

        let requiredGridRowParameterInputs = values.mode ? [ ...values.mode.fields ] : [];
        _.forEach(treatmentGrids, (grid, gk) => {
            _.forEach(requiredGridRowParameterInputs, (param, pk) => {
                if (grid[ param ] && grid[ param ].errors.length) {
                    errors.push({
                        id: `${param} ${gk}`,
                        error: grid[ param ].errors[ 0 ]
                    })
                }
            })
        })

        // console.log('errors arr: ', errors)
        return errors;
    }

    return (
        <div>
            <div className={ 'alma-box-header' }>
                <h3>{ $t('global.treatments.addTreatment') }</h3>
            </div>

            <div className={ 'alma-box-content' }>
                <div className={ 'alma-fields-section' }>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.treatments.time') }</div>
                            <InputWithValidation
                                name="created_at"
                                validations={ [ 'required' ] }
                                onChange={ (data) => fieldChangeHandler('created_at', data) }
                                touched={ formSent }
                                type="datetime-local"
                                value={ values.created_at }
                            // placeholder={'placeholder'}
                            />
                        </div>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.treatments.staff') }</div>
                            <MultiSelectWithValidation
                                required
                                options={ staffOptions }
                                selected={ values.staff }
                                searchable
                                onValueChange={ (data) => fieldChangeHandler('staff', data) }
                                touched={ formSent }
                            />
                        </div>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.treatments.patient') }</div>
                            <MultiSelectWithValidation
                                required
                                options={ patientOptions }
                                selected={ values.patient }
                                searchable
                                onValueChange={ (data) => fieldChangeHandler('patient', data) }
                                touched={ formSent }
                            />
                        </div>
                        {/*<div className={'alma-field-container'}>*/ }
                        {/*</div>*/ }
                    </div>

                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.treatments.area') }</div>
                            <MultiSelectWithValidation
                                required
                                options={ areasOptions }
                                selected={ values.area }
                                searchable
                                onValueChange={ (data) => fieldChangeHandler('area', data) }
                                touched={ formSent }
                            />
                        </div>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.treatments.skinType') }</div>
                                <SkinTypeSelector
                                    skinType={ values.skin_id }
                                    onValueChange={ (data) => fieldChangeHandler('skin_id', { value: data }) } />
                                <div
                                    className={ styles.error }>{ (formSent && !values.skin_id ? $t('validation.general.required') : ' ') }</div>
                            </div>
                        </div>
                        <div className={ 'alma-field-container' }>
                        </div>
                    </div>
                </div>
                <div className={ 'alma-fields-section' } style={ { borderBottom: 'none' } }>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.treatments.platform') }</div>
                            <MultiSelectWithValidation
                                required
                                options={ platformOptions }
                                selected={ values.platform }
                                searchable
                                onValueChange={ (data) => fieldChangeHandler('platform', data) }
                                touched={ formSent }
                            />
                        </div>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.treatments.applicator') }</div>
                            <MultiSelectWithValidation
                                required
                                options={ applicatorOptions }
                                selected={ values.applicator }
                                searchable
                                onValueChange={ (data) => fieldChangeHandler('applicator', data) }
                                touched={ formSent }
                            />
                        </div>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.treatments.treatmentMode') }</div>
                            <MultiSelectWithValidation
                                required
                                options={ treatmentModesOptions }
                                selected={ values.mode }
                                onValueChange={ (data) => fieldChangeHandler('mode', data) }
                                touched={ formSent }
                            />
                        </div>
                        <div className={ 'alma-field-container' }>
                            {/*{gridSizeOptions.length}*/ }
                            { gridSizeOptions.length ?
                                <>
                                    <div className={ 'alma-field-header' }>{ $t('global.treatments.gridSize') }</div>
                                    <MultiSelectWithValidation
                                        required
                                        options={ gridSizeOptions }
                                        selected={ values.grid_size }
                                        onValueChange={ (data) => fieldChangeHandler('grid_size', data) }
                                        touched={ formSent }
                                    />
                                </>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
                <div>
                    { showTreatmentGridsRows ?
                        <div className={ styles.treatmentGridRows }>
                            <div>
                                { $t('global.treatments.treatmentGrids') }
                            </div>
                            { treatmentGrids.map((v, k) => {
                                return (
                                    <div className={ `alma-fields-row ${styles.gridRow}` }
                                        key={ `treatment-grid-row-${k}` }>
                                        { values.mode && values.mode.fields.includes('energy') && treatmentGrids[ k ] && treatmentGrids[ k ].energy ?
                                            <div className={ `alma-field-container` }
                                                style={ { maxWidth: '150px', minWidth: '150px', padding: '0, 5px' } }>
                                                <>
                                                    <div
                                                        className={ `${styles[ 'field-name' ]}` }>{ $t('global.treatments.energy') }</div>
                                                    <div className={ `${styles[ 'field-input' ]}` }>
                                                        <InputWithValidation
                                                            key={ `treatment-grid-row-input-energy-${k}` }
                                                            name="tel"
                                                            validations={ [ 'required', 'min(0)', 'max(50)', 'integer' ] }
                                                            onChange={ (data, e) => treatmentGridChangeHandler(e, k, 'energy', { value: data }) }
                                                            touched={ formSent }
                                                            type="text"
                                                            value={ treatmentGrids[ k ].energy }
                                                            styles={ { maxWidth: '150px' } }
                                                        // placeholder={'placeholder'}
                                                        />
                                                    </div>
                                                </>
                                            </div>
                                            :
                                            null
                                        }
                                        { values.mode && values.mode.fields.includes('fluence') && treatmentGrids[ k ] && treatmentGrids[ k ].fluence ?
                                            <div className={ 'alma-field-container' }
                                                style={ { maxWidth: '150px', minWidth: '150px', padding: '0, 5px' } }>
                                                <>
                                                    <div
                                                        className={ `${styles[ 'field-name' ]}` }>{ $t('global.treatments.fluence') }</div>
                                                    <div className={ `${styles[ 'field-input' ]}` }>
                                                        <InputWithValidation
                                                            key={ `treatment-grid-row-input-fluence-${k}` }
                                                            name="fluence"
                                                            validations={ [ 'required', 'min(0)', 'max(20)', 'integer' ] }
                                                            onChange={ (data, e) => treatmentGridChangeHandler(e, k, 'fluence', { value: data }) }
                                                            touched={ formSent }
                                                            type="text"
                                                            value={ treatmentGrids[ k ].fluence }
                                                            styles={ { maxWidth: '150px' } }
                                                        // placeholder={'placeholder'}
                                                        />
                                                    </div>
                                                </>
                                            </div>
                                            :
                                            null
                                        }
                                        { values.mode && values.mode.fields.includes('frequency') && treatmentGrids[ k ] && treatmentGrids[ k ].frequency ?
                                            <div className={ 'alma-field-container' }
                                                style={ { maxWidth: '150px', minWidth: '150px', padding: '0, 5px' } }>
                                                <>
                                                    <div
                                                        className={ `${styles[ 'field-name' ]}` }>{ $t('global.treatments.frequency') }</div>
                                                    <div className={ `${styles[ 'field-input' ]}` }>
                                                        <InputWithValidation
                                                            key={ `treatment-grid-row-input-frequency-${k}` }
                                                            name="frequency"
                                                            validations={ [ 'required', 'min(0)', 'max(10)', 'integer' ] }
                                                            onChange={ (data, e) => treatmentGridChangeHandler(e, k, 'frequency', { value: data }) }
                                                            touched={ formSent }
                                                            type="text"
                                                            value={ treatmentGrids[ k ].frequency }
                                                            styles={ { maxWidth: '150px' } }
                                                        // placeholder={'placeholder'}
                                                        />
                                                    </div>
                                                </>
                                            </div>
                                            :
                                            null
                                        }
                                        { values.mode && values.mode.fields.includes('lasing_time') && treatmentGrids[ k ] && treatmentGrids[ k ].lasing_time ?
                                            <div className={ 'alma-field-container' }
                                                style={ { maxWidth: '150px', minWidth: '150px', padding: '0, 5px' } }>
                                                <>
                                                    <div
                                                        className={ `${styles[ 'field-name' ]}` }>{ $t('global.treatments.lasing_time') }</div>
                                                    <div className={ `${styles[ 'field-input' ]}` }>
                                                        <InputWithValidation
                                                            key={ `treatment-grid-row-input-frequency-${k}` }
                                                            name="lasing_time"
                                                            validations={ [ 'required', 'min(0)', 'max(3600)', 'integer' ] }
                                                            onChange={ (data, e) => treatmentGridChangeHandler(e, k, 'lasing_time', { value: data }) }
                                                            touched={ formSent }
                                                            type="text"
                                                            value={ treatmentGrids[ k ].lasing_time }
                                                            styles={ { maxWidth: '150px' } }
                                                        // placeholder={'placeholder'}
                                                        />
                                                    </div>
                                                </>
                                            </div>
                                            :
                                            null
                                        }
                                        <>
                                            { treatmentGrids.length === k + 1 ?
                                                <div className={ styles.gridRowAddRemove }>
                                                    {
                                                        treatmentGrids.length > 1 ?
                                                            <div onClick={ (e) => changeGridsCount(e, 0) }>
                                                                <MdRemoveCircleOutline style={ { fontSize: '25px' } } />
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        treatmentGrids.length < 4 ?
                                                            <div onClick={ (e) => changeGridsCount(e, 1) }>
                                                                <MdAddCircleOutline style={ { fontSize: '25px' } } />
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                :
                                                null
                                            }
                                        </>
                                    </div>
                                )
                            }) }
                        </div>
                        :
                        null
                    }
                </div>
            </div>

            <div className={ 'alma-box-footer' }>
                <div className={ styles.formError }>{ formError }</div>
                <div className={ 'alma-button' } onClick={ async () => await formSentClickHandler() }>
                    { $t('global.treatments.addTreatment') }
                </div>
            </div>
        </div>
    )
}


export default AddTreatment;
